import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// STATE AND STORE
// LIBS
import {
  fioLitleTruncateFromObject,
  sumFormat
} from "../../../lib/helpers/strings";
import { getDateFormat } from "../../../lib/helpers/dates";
import {
  getStatusString,
  getStatusClassString
} from "../../../lib/helpers/bilets";
import {
  getSumPercent,
  getNewSumPercent,
  getFinesToHistory,
  checkBiletHistoryWithBlank,
  getSumAll
} from "../../../lib/helpers/history";
import { sortOnCreatedAt } from "../../../lib/helpers/sort";

// UI
import { Header, Table, VirtualDiv } from "../../../ui";
import IconEdit from "../../../ui/src/ui/components/icons/edit";
import IconAddFilled from "../../../ui/src/ui/components/icons/addFilled";
import IconMinusFilled from "../../../ui/src/ui/components/icons/minusFilled";
import IconClockFilled from "../../../ui/src/ui/components/icons/clockFilled";
import IconRefreshFilled from "../../../ui/src/ui/components/icons/refreshFilled";

export default class TableHistorys extends Component {
  static propTypes = {
    biletId: PropTypes.string.isRequired,
    historysOriginal: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    blanks: PropTypes.arrayOf(PropTypes.shape({}))
  };

  state = {
    loading: true,
    historys: [],
    historysFooter: {
      countAll: 0,
      getPercent: 0,
      getFine: 0,
      getAll: 0
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.historysOriginal.length !== this.props.historysOriginal.length
    ) {
      this.getHistory(nextProps.historysOriginal);
    }
  }

  getHistory = historysOriginal => {
    if (historysOriginal && historysOriginal.length) {
      historysOriginal.sort(sortOnCreatedAt);
    }

    let historys = [];

    let historysFooter = {
      countAll: 0,
      getPercent: 0,
      getFine: 0,
      getAll: 0
    };

    for (let item of historysOriginal) {
      let historyItem = {
        _id: null,
        _method: null,
        created_at: null,
        user_id: {},
        _field: {},
        historyErrors: {
          createdAt: null,
          sumReturn: null,
          sumAll: null
        },
        fines: [],
        sumPercent: null,
        sumGetAll: null,
        sumPercentNew: null,
        IconStatus: null
      };

      // PREPARE
      const sumPercent = getSumPercent(item);
      const fines = getFinesToHistory(item);
      const sumPercentNew = getNewSumPercent(historysOriginal, item);
      const sumGetAll = getSumAll(item, sumPercent, fines.allSum, false);
      const IconStatus = getStatusClassString(item._method);
      const historyErrors = checkBiletHistoryWithBlank(
        {
          createdAt: item.created_at,
          getSumAll: typeof sumGetAll === "number" ? sumGetAll : 0,
          sumPercentNew: typeof sumPercentNew === "number" ? sumPercentNew : 0,
          sumReturn: item._field.sum_return,
          sumGive: item._field.sum_give,
          method: item._method
        },
        this.props.blanks
      );

      // historysFooter
      historysFooter.countAll += 1;

      if (typeof sumPercent === "number") {
        historysFooter.getPercent += sumPercent;
      }
      historysFooter.getFine += parseFloat(fines.allSum || 0, 0);
      historysFooter.getAll =
        historysFooter.getPercent + historysFooter.getFine;

      // historys
      historyItem._id = item._id;
      historyItem._method = item._method;
      historyItem.created_at = item.created_at;
      historyItem.user_id = item.user_id;
      historyItem._field = item._field;
      historyItem.historyErrors = historyErrors;
      historyItem.fines = fines;
      historyItem.sumPercent = sumPercent;
      historyItem.sumGetAll = sumGetAll;
      historyItem.sumPercentNew = sumPercentNew;
      historyItem.IconStatus = IconStatus;

      historys.push(historyItem);
    }

    this.setState({
      loading: false,
      historysOriginal,
      historys,
      historysFooter
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => 1 + i,
        footer: {}
      },
      {
        title: "Дата",
        suffix: "операции",
        render: ({ item }) => {
          return item.historyErrors.createdAt ? (
            <strong className="color-error">
              {getDateFormat(item.created_at)}
            </strong>
          ) : (
            getDateFormat(item.created_at)
          );
        },
        footer: {
          title: "Итого",
          colSpan: 2
        }
      },
      {
        title: "Вид",
        suffix: "операции",
        render: ({ item }) => {
          let icon = null;

          switch (item.IconStatus) {
            case "color-dark":
              icon = <IconAddFilled className="icon-td icon-dark" />;
              break;
            case "color-warning":
              icon = (
                <IconClockFilled className="icon-td icon-warning-active" />
              );
              break;
            case "color-error":
              icon = <IconMinusFilled className="icon-td icon-error" />;
              break;
            case "color-success":
              icon = (
                <IconRefreshFilled className="icon-td icon-success-active" />
              );
              break;
            default:
              break;
          }

          return (
            <VirtualDiv>
              {icon}
              {getStatusString(item._method)}
            </VirtualDiv>
          );
        }
      },
      {
        title: "Проценты",
        suffix: "полученные",
        text: "right",
        render: ({ item }) => sumFormat(item.sumPercent),
        footer: {
          title: sumFormat(this.state.historysFooter.getPercent)
        }
      },
      {
        title: "Штраф",
        suffix: "полученный",
        text: "right",
        render: ({ item }) => {
          if (item.fines && item.fines.list && item.fines.list.length) {
            return item.fines.list.map(fine => {
              return (
                <div key={`bilet-history-fine-${fine._id}`}>
                  {fine.description}
                  {sumFormat(fine.sum)}
                </div>
              );
            });
          } else {
            return "-";
          }
        },
        footer: {
          title: sumFormat(this.state.historysFooter.getFine)
        }
      },
      {
        title: "Сумма",
        prefix: "итого",
        suffix: "полученная",
        text: "right",
        render: ({ item }) => {
          if (item.sumGetAll !== 0) {
            if (item.historyErrors.sumAll) {
              return (
                <strong className="color-error">
                  {sumFormat(item.sumGetAll)}
                </strong>
              );
            } else {
              return sumFormat(item.sumGetAll);
            }
          } else {
            return "-";
          }
        },
        footer: {
          title: sumFormat(
            this.state.historysFooter.getPercent +
              this.state.historysFooter.getFine
          )
        }
      },
      {
        title: "Дата",
        suffix: "возврата",
        render: ({ item }) => getDateFormat(item._field.date_return),
        footer: {
          colSpan: 6
        }
      },
      {
        title: "Проценты",
        suffix: "новые",
        text: "right",
        render: ({ item }) => {
          if (item.historyErrors.sumReturn) {
            return (
              <strong className="color-error">
                {sumFormat(item.sumPercentNew)}
              </strong>
            );
          } else {
            return sumFormat(item.sumPercentNew);
          }
        }
      },
      {
        title: "Сумма",
        suffix: "возврата",
        text: "right",
        render: ({ item }) => {
          if (item.historyErrors.sumReturn) {
            return (
              <strong className="color-error">
                {sumFormat(item._field.sum_return)}
              </strong>
            );
          } else {
            return sumFormat(item._field.sum_return);
          }
        }
      },
      {
        title: "Дата",
        suffix: "обновления билета",
        render: ({ item }) => getDateFormat(item._field.updated_at)
      },
      {
        title: "Ответсвенный",
        suffix: "за операцию",
        render: ({ item }) => {
          return (
            <Link to={`/users/${item.user_id._id}`}>
              {fioLitleTruncateFromObject(item.user_id)}
            </Link>
          );
        }
      },
      {
        title: "",
        className: "icon",
        render: ({ item }) => {
          return (
            <Link to={`/bilets/${this.props.biletId}/edit/history/${item._id}`}>
              <IconEdit />
            </Link>
          );
        }
      }
    ];
  };

  render() {
    return (
      <div>
        <Header size={4}>История операций</Header>

        <Table
          columns={this.getTableColumns()}
          data={this.state.historys}
          loading={this.state.loading}
        />
      </div>
    );
  }
}
